// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"171":"OrderSuccessPage","810":"NotFound"}[chunkId] || chunkId) + "." + {"171":"04b11506","688":"559ebdee","810":"fd98cc79"}[chunkId] + ".chunk.css";
};